type Props = {
  data: {
    desc: string;
    date: string;
  }[];
};

function TimelineSection({ data }: Props) {
  return (
    <div className="timeline">
      {data.map((item, index) => (
        <div className="event" key={index}>
          <div className="dot"></div>
          <div className="v">
            <div className="timeline-date">{item.date}</div>
            <div className="timeline-desc">{item.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TimelineSection;
